"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationSubscriptionsDto = instanceOfNotificationSubscriptionsDto;
exports.NotificationSubscriptionsDtoFromJSON = NotificationSubscriptionsDtoFromJSON;
exports.NotificationSubscriptionsDtoFromJSONTyped = NotificationSubscriptionsDtoFromJSONTyped;
exports.NotificationSubscriptionsDtoToJSON = NotificationSubscriptionsDtoToJSON;
exports.NotificationSubscriptionsDtoToJSONTyped = NotificationSubscriptionsDtoToJSONTyped;
const NotificationSectionDto_1 = require("./NotificationSectionDto");
/**
 * Check if a given object implements the NotificationSubscriptionsDto interface.
 */
function instanceOfNotificationSubscriptionsDto(value) {
    if (!('sections' in value) || value['sections'] === undefined)
        return false;
    return true;
}
function NotificationSubscriptionsDtoFromJSON(json) {
    return NotificationSubscriptionsDtoFromJSONTyped(json, false);
}
function NotificationSubscriptionsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sections': (json['sections'].map(NotificationSectionDto_1.NotificationSectionDtoFromJSON)),
    };
}
function NotificationSubscriptionsDtoToJSON(json) {
    return NotificationSubscriptionsDtoToJSONTyped(json, false);
}
function NotificationSubscriptionsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'sections': (value['sections'].map(NotificationSectionDto_1.NotificationSectionDtoToJSON)),
    };
}
//# sourceMappingURL=NotificationSubscriptionsDto.js.map